// Modules
import styles from "components/atoms/StepInfo/StepInfo.module.css";
import theme from "styles/theme";

// Utils
import getIcon from "utils/getIcon";

export type StepInfoProps = {
	message: string;
};

const StepInfo = ({ message }: StepInfoProps): JSX.Element => {
	return (
		<div className={styles?.main_wrappper}>
			<div className={styles?.info_icon_wrapper}>{getIcon({ icon: "infoIcon", iconColor: theme.colors.lightBlue.valueOf() })}</div>
			<span className={styles?.step_info_message}>{message}</span>
		</div>
	);
};

export default StepInfo;
